import { z } from 'zod';
import { decimalStringSchema, localizedTextSchema, positiveDecimalStringSchema, uuidSchema, } from './common.js';
import { unitDimensionSchema, unitSystemSchema } from './enums.js';
export const unitLabelsSchema = z.object({
    singular: localizedTextSchema,
    plural: localizedTextSchema,
    abbreviation: localizedTextSchema,
});
export const unitSchema = z.object({
    id: uuidSchema,
    code: z.string().min(1).max(32),
    dimension: unitDimensionSchema,
    system: unitSystemSchema,
    /** Factor to the dimension base unit (g for MASS, ml for VOLUME, 1 for COUNT). */
    baseFactor: positiveDecimalStringSchema,
    labels: unitLabelsSchema,
    aliases: z.array(z.string()),
    isActive: z.boolean(),
    position: z.number().int(),
});
export const unitWriteSchema = unitSchema
    .omit({ id: true })
    .partial({ isActive: true, position: true, aliases: true });
export const ingredientDensitySchema = z.object({
    id: uuidSchema,
    ingredientName: z.string().min(1).max(120),
    gramsPerMilliliter: positiveDecimalStringSchema,
    note: z.string().max(200).nullable(),
});
export const ingredientDensityWriteSchema = ingredientDensitySchema.omit({ id: true });
export const convertQuantityRequestSchema = z.object({
    quantity: decimalStringSchema,
    fromUnitCode: z.string(),
    toUnitCode: z.string(),
    ingredientName: z.string().optional(),
});
export const convertQuantityResponseSchema = z.object({
    quantity: decimalStringSchema,
    unitCode: z.string(),
    usedDensity: z.boolean(),
});
//# sourceMappingURL=units.js.map